import camelcaseKeys from 'camelcase-keys';

export const getters = {
  getOrders($state) {
    return $state.sortOrder.map(orderId => $state.records[orderId]);
  },
  getOrdersList($state) {
    const orders = $state.sortOrder.map(orderId => $state.records[orderId]);
    return camelcaseKeys(orders, { deep: true });
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getOrder: $state => id => {
    const order = $state.records[id];
    return order || {};
  },
  getOrderById: $state => id => {
    const order = $state.records[id];
    return camelcaseKeys(order || {}, { deep: true });
  },
  getMeta: $state => {
    return $state.meta;
  },
  getAppliedOrderFilters: _state => {
    return _state.appliedFilters;
  },
  getAppliedOrderFiltersV4: _state => {
    return _state.appliedFilters.map(camelcaseKeys);
  },
};
